import { render, staticRenderFns } from "./tuandco-background-close.vue?vue&type=template&id=0c8f395d&"
import script from "./tuandco-background-close.vue?vue&type=script&lang=ts&"
export * from "./tuandco-background-close.vue?vue&type=script&lang=ts&"
import style0 from "./tuandco-background-close.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports